var authorizePaymentUrl = '';
var updateGooglePayDataUrl = '';
var googlePayTransactionInfo = '';
var googlePayShippingOptions = '';
var googlePayType = 'default';
var paymentsClient = null;
var gateway = '';
var gatewayMerchantId = '';
var allowedCardNetworks = [];
var allowedCardAuthMethods = [];
var allowedCountryCodes = [];
var merchantId = '';
var merchantName = '';
var environment = 'TEST';
var ddcSessionId = '';
var hideGooglePayButton = false;
var selectedShippingMethodID = '';
var selectedStoreID = '';

var baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
};

var tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
        'gateway': gateway,
        'gatewayMerchantId': gatewayMerchantId
    }
};

var baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
        allowedAuthMethods: allowedCardAuthMethods,
        allowedCardNetworks: allowedCardNetworks,
        billingAddressRequired: true,
        billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
        }
    }
};

var cardPaymentMethod = Object.assign(
    {},
    baseCardPaymentMethod,
    {
        tokenizationSpecification: tokenizationSpecification
    }
);

function getGoogleIsReadyToPayRequest() {
    return Object.assign(
        {},
        baseRequest,
        {
            allowedPaymentMethods: [baseCardPaymentMethod]
        }
    );
}

function getGoogleDefaultShippingOptions() {
    var shippingOptions = googlePayShippingOptions.map(function(option) {
        return {
            id: option.identifier,
            label: option.label,
            description: option.detail
        };
    });

    var defaultSelectedOptionId = shippingOptions[0].id;

    return {
        defaultSelectedOptionId: defaultSelectedOptionId,
        shippingOptions: shippingOptions
    };
}

function getShippingCosts() {
    var shippingCosts = {};
    var shippingOptions = googlePayShippingOptions;
    shippingOptions.forEach(function(option) {
        shippingCosts[option.identifier] = option.amount;
    });

    return shippingCosts;
}

function calculateNewTransactionInfo(shippingOptionId) {
    var newTransactionInfo = getGoogleTransactionInfo();

    var shippingCost = getShippingCosts()[shippingOptionId];
    var defaultShippingOptions = getGoogleDefaultShippingOptions();
    var shippingOptionLabel = defaultShippingOptions.shippingOptions.find(function(option) {
        return option.id === shippingOptionId;
    }).label;

    var newDisplayItems = newTransactionInfo.displayItems.filter(function(item) {
        return item.type !== "SHIPPING_OPTION";
    });
    newDisplayItems.push({
        label: shippingOptionLabel,
        type: "SHIPPING_OPTION",
        price: shippingCost
    });

    newTransactionInfo.displayItems = newDisplayItems;

    var totalPrice = 0.00;
    newTransactionInfo.displayItems.forEach(function(displayItem) {
        totalPrice += parseFloat(displayItem.price);
    });

    newTransactionInfo.totalPrice = totalPrice.toString();

    return newTransactionInfo;
}

function getGoogleShippingAddressParameters() {
    return  {
        allowedCountryCodes: allowedCountryCodes,
        phoneNumberRequired: true
    };
}

function onPaymentDataChanged(intermediatePaymentData) {
    return new Promise(function(resolve, reject) {

        var shippingAddress = intermediatePaymentData.shippingAddress;
        var shippingOptionData = intermediatePaymentData.shippingOptionData;
        var paymentDataRequestUpdate = {};

        if (intermediatePaymentData.callbackTrigger == "INITIALIZE" || intermediatePaymentData.callbackTrigger == "SHIPPING_ADDRESS") {
            paymentDataRequestUpdate.newShippingOptionParameters = getGoogleDefaultShippingOptions();
            var selectedShippingOptionId = paymentDataRequestUpdate.newShippingOptionParameters.defaultSelectedOptionId;
            paymentDataRequestUpdate.newTransactionInfo = calculateNewTransactionInfo(selectedShippingOptionId);

            resolve(paymentDataRequestUpdate);

        } else if (intermediatePaymentData.callbackTrigger == "SHIPPING_OPTION") {
            paymentDataRequestUpdate.newTransactionInfo = calculateNewTransactionInfo(shippingOptionData.id);

            resolve(paymentDataRequestUpdate);
        }
    });
}

function getGooglePaymentDataRequest() {
    var paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    paymentDataRequest.merchantInfo = {
        merchantId: merchantId,
        merchantName: merchantName
    };

    if (googlePayType === 'onlyCard') {
        paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"];
        paymentDataRequest.emailRequired = true;
    } else {
        paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION", "SHIPPING_ADDRESS",  "SHIPPING_OPTION"];
        paymentDataRequest.shippingAddressRequired = true;
        paymentDataRequest.shippingAddressParameters = getGoogleShippingAddressParameters();
        paymentDataRequest.shippingOptionRequired = true;
        paymentDataRequest.emailRequired = true;
    }

    return paymentDataRequest;
}

function getGooglePaymentsClient() {
    if (googlePayType === 'onlyCard') {
        paymentDataCallbacks = {
            onPaymentAuthorized: onPaymentAuthorized
        };
    } else {
        paymentDataCallbacks = {
            onPaymentAuthorized: onPaymentAuthorized,
            onPaymentDataChanged: onPaymentDataChanged
        };
    }

    paymentsClient = new google.payments.api.PaymentsClient({
        environment: environment,
        paymentDataCallbacks: paymentDataCallbacks
    });

    return paymentsClient;
}

function onPaymentAuthorized(paymentData) {
    return new Promise(function(resolve, reject) {
        // handle the response
        processPayment(paymentData)
            .then(function() {
                resolve({transactionState: 'SUCCESS'});
            })
            .catch(function() {
                resolve({
                    transactionState: 'ERROR',
                    error: {
                        intent: 'PAYMENT_AUTHORIZATION',
                        message: 'PAYMENT_AUTHORIZATION_ERROR',
                        reason: 'PAYMENT_DATA_INVALID'
                    }
                });
            });
    });
}

function processPayment(paymentData) {
    var customPaymentData = Object.assign({}, paymentData, { googlePayType: googlePayType, ddcSessionId: ddcSessionId });

    return fetch(authorizePaymentUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(customPaymentData)
    })
    .then(function(response) {
        return response.json();
    })
    .then(function(responseData) {
        if (responseData && responseData.success) {
            window.location.href = responseData.redirectUrl;
        } else {
            return Promise.reject();
        }
    });
}

function initGooglePayConfiguration(dataset) {
    if (dataset) {
        authorizePaymentUrl = dataset.authorizePaymentUrl;
        updateGooglePayDataUrl = dataset.updateGooglePayDataUrl;
        googlePayTransactionInfo = JSON.parse(dataset.googlePayTransactionInfoJson);
        googlePayShippingOptions = JSON.parse(dataset.googlePayShippingOptionsJson);
        googlePayType = dataset.googlePayType || 'default';
        gateway = dataset.gateway;
        gatewayMerchantId = dataset.gatewayMerchantId;
        merchantId = dataset.merchantId;
        merchantName = dataset.merchantName;
        allowedCardNetworks = JSON.parse(dataset.allowedCardNetworksJson);
        allowedCardAuthMethods = JSON.parse(dataset.allowedCardAuthMethodsJson);
        allowedCountryCodes = JSON.parse(dataset.allowedCountryCodesJson);
        environment = dataset.environment || 'TEST';
        hideGooglePayButton = dataset.hideGooglePayButton === 'true';
        selectedShippingMethodID = dataset.selectedShippingMethodId || '';
        selectedStoreID = dataset.selectedStoreId || '';
    }

    tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
            'gateway': gateway,
            'gatewayMerchantId': gatewayMerchantId
        }
    };

    baseCardPaymentMethod = {
        type: 'CARD',
        parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks,
            billingAddressRequired: true,
            assuranceDetailsRequired: true,
            billingAddressParameters: {
                format: 'FULL',
                phoneNumberRequired: true
            }
        }
    };

    cardPaymentMethod = Object.assign(
        {},
        baseCardPaymentMethod,
        {
            tokenizationSpecification: tokenizationSpecification
        }
    );
}

function addGooglePayButton() {
    var paymentsClient = getGooglePaymentsClient();

    var googlePayButtonContainerList = document.querySelectorAll('.js-google-pay-button-container');
    googlePayButtonContainerList.forEach(function(container) {
        container.style.display = 'none';
        container.innerHTML = '';

        if (!hideGooglePayButton) {
            var button = paymentsClient.createButton(
                {
                    onClick: onGooglePaymentButtonClicked,
                    allowedPaymentMethods: [baseCardPaymentMethod],
                    buttonColor: 'default',
                    buttonType: 'plain',
                    buttonRadius: 30,
                    buttonBorderType: 'default_border',
                    buttonLocale: 'en',
                    buttonSizeMode: 'fill',
                }
            );

            container.appendChild(button);
            container.style.display = 'block';
        }
    });
}

function getGoogleTransactionInfo() {
    return googlePayTransactionInfo;
}

function prefetchGooglePaymentData() {
    var paymentDataRequest = getGooglePaymentDataRequest();
    // transactionInfo must be set but does not affect cache
    paymentDataRequest.transactionInfo = {
        totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
        currencyCode: 'GBP'
    };

    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.prefetchPaymentData(paymentDataRequest);
}

function onGooglePaymentButtonClicked() {
    var paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();

    var paymentsClient = getGooglePaymentsClient();

    // needed to prevent conflict with existing DDC iframe for multiple payment methods
    window.googlePayPopUpActive = true;

    performDDCGooglePay()
        .then(data => {
            return paymentsClient.loadPaymentData(paymentDataRequest);
        });
}

function onGooglePayLoaded() {
    var googlePayButtonContainerList = document.querySelectorAll('.js-google-pay-button-container');
    if (!googlePayButtonContainerList.length) {
        return;
    }

    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
        .then(function(response) {
            if (response.result) {
                addGooglePayButton();
                prefetchGooglePaymentData();
            } else {
                document.querySelectorAll('.js-google-pay-button-container')
                    .forEach(function(container) {
                        var paymentWrapper = container.closest('.js-payment_method_wrapper');
                        container.remove();
                        if (paymentWrapper) {
                            paymentWrapper.remove();
                        }
                    }
                );
            }
        })
        .catch(function(err) {
            console.error(err);
        });
}

function updateGooglePayData() {
    fetch(updateGooglePayDataUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            googlePayType: googlePayType
        })
    })
    .then(function(response) {
        return response.json();
    })
    .then(function(responseData) {
        googlePayTransactionInfo = responseData.googlePayTransactionInfoJSON;
        googlePayShippingOptions = responseData.googlePayShippingOptionsJSON;
        googlePayType = responseData.googlePayType || 'default';
        hideGooglePayButton = responseData.hideGooglePayButton;
        selectedShippingMethodID = responseData.selectedShippingMethodId || '';
        selectedStoreID = responseData.selectedStoreId || '';

        onGooglePayLoaded();
    });
}

function hideGooglePay() {
    var googlePayButtonContainerList = document.querySelectorAll('.js-google-pay-button-container');
    googlePayButtonContainerList.forEach(function(container) {
        container.style.display = 'none';
    });
}

function initEventListeners() {
    var $document = $(document);

    $document.on('googlePayShippingMethodChanged', function(params, shippingMethodID) {
        selectedShippingMethodID = shippingMethodID || '';
        selectedStoreID = null;

        if (selectedShippingMethodID && (
            (selectedShippingMethodID === 'deliveryToStoreGBP' && selectedStoreID)
            || selectedShippingMethodID !== 'deliveryToStoreGBP'
        )) {
            updateGooglePayData();
        }
    });

    $document.on('googlePayStoreIdChanged', function(params, storeID) {
        selectedStoreID = storeID || '';

        if (selectedStoreID) {
            updateGooglePayData();
        }
    });
}

function init() {
    initEventListeners();

    if (typeof google !== 'undefined') {
        var googlePayButtonContainerList = document.querySelectorAll('.js-google-pay-button-container');
        if (googlePayButtonContainerList.length) {
            var container = googlePayButtonContainerList[0];

            initGooglePayConfiguration(container.dataset);
        }

        onGooglePayLoaded();
    } else {
        window.addEventListener('googlepayloaded', function() {
            onGooglePayLoaded();
        }, { once: true });
    }
}

/**
 * Insert DDC iframe for into page and submit the form inside it to able to get DDC sessionId
 * @returns
 */
function performDDCGooglePay() {
    var urls = (typeof window !== "undefined" ? window['Urls'] : typeof global !== "undefined" ? global['Urls'] : null);

    return fetch(urls.getDDCIframeGooglePay + '?_t=' + new Date().getTime())
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            $('#ddcIframe').remove();

            var $iframe = $('<iframe></iframe>')
                .attr('id', 'ddcIframe')
                .addClass('hidden')
                .attr('target', '_top');

            var formText = [
                "<form id='collectionForm' method='POST' action='" + data.actionURL + "'>",
                    "<input type='hidden' name='Bin' value='' />",
                    "<input type='hidden' name='JWT' value=" + data.worldpayJWT + " />",
                "</form>"
            ].join('\n');

            $iframe.attr('srcdoc', formText);
            $iframe.on('load', ddcIframeLoaded);

            $('body').append($iframe);
        });
}

function ddcIframeLoaded() {
    var el = document.getElementById('ddcIframe');
    var collectionForm = el.contentWindow.document.getElementById('collectionForm');
    collectionForm.submit();

    window.addEventListener("message", function (event) {
        var data = JSON.parse(event.data);
        if (window.googlePayPopUpActive && data !== undefined && data.Status) {
            ddcSessionId = data.SessionId;
        }
    }, false);
}

module.exports = {
    init: init,
    updateGooglePayData: updateGooglePayData,
    hideGooglePay: hideGooglePay
};
